interface Adaptation {
  chat_id: string;
  template_id: number;
}

export function livechatTemplatesCancelEditAdapter(
  attendanceId: string,
  templateId: number,
): Adaptation {
  return {
    chat_id: attendanceId,
    template_id: templateId,
  }
}
